export default "__VITE_ASSET__DQyxGL$v__"